import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";


import { AuthContext } from "../../contexts/auth";
import { useNavigate, useParams } from "react-router-dom";

import { permite_acesso, PegarDados1, status2 } from "../../services/api";

import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import { set, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Percent_Lanc_Rede from "../Modulos/Notas_percent_lancadas";
import Media_Comparativa_geral from "../Modulos/media_comparativa_geral";
import Ranking_Alunos_Serie from "../Modulos/ranking_alunos_unidade";
import Percent_Lanc_Rede_unidade from "../Modulos/Notas_Percent_Lanacadas_unidade";
import Percent_Lanc_Rede_Prazo from "../Modulos/Prazos_rede_detalhe";
import Prazo_Rede from "../Modulos/prazo_rede";
import DesempenhoPorFaixa from "../Modulos/Qtd_Alunos_faixa_desempenho";

import Checkbox from "../Components/checkbox";

// import { Row, Form, Button, Container, Tab, Tabs, Table, Col } from "react-bootstrap";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Table from "react-bootstrap/Table";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/esm/Col";
import { keyboard } from "@testing-library/user-event/dist/keyboard";
import Accordion from 'react-bootstrap/Accordion';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Collapse from 'react-bootstrap/Collapse';


import './index.css';



const schema = yup.object({}).required();

const Homepage = () => {

    const stauts = status2();
    console.log("Status2", stauts);


    const usuario = JSON.parse(localStorage.getItem("user"));
    const perfil = JSON.parse(localStorage.getItem("perfil"));
    const token = localStorage.getItem("token");



    // CONTROLE(FUNCIONARIO,TOKEN,COD_UNI)

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    const avaliacaoOptions = ['AS1', 'AQ1', 'AP1', 'AV1', 'AS2', 'AQ2', 'AP2', 'AV2', 'AS3', 'AQ3', 'AP3', 'AV3', 'AS4', 'AQ4', 'AP4', 'AV4'];


    const { authenticated, logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const [acesso, setAcesso] = useState(false);
    const [avaliacao, setAvaliacao] = useState("AV3");

    const [dataInicio, setDataInicio] = useState('2026-02-04'); // Formato ISO (YYYY-MM-DD)
    // const [dataFim, setDataFim] = useState(new Date().toISOString().split('T')[0]);
    // const [dataFim, setDataFim] = useState('2024-03-31');
    const amanha = new Date();
    amanha.setDate(amanha.getDate() + 1);
    const novaDataFim = amanha.toISOString().split('T')[0];

    const hoje = new Date();
    const diadehoje = hoje.toISOString().split('T')[0];

    const [dataFim, setDataFim] = useState(diadehoje);

    console.log("Antes", dataInicio);

    // const [startDate, setStartDate] = useState('2022-09-01');
    // const [endDate, setEndDate] = useState(getCurrentDate());

    function formatarData(dataOriginal) {
        // Divide a string da data em ano, mês e dia
        const partes = dataOriginal.split('-');
        // Verifica se a string está no formato correto (ANO-MES-DIA)
        if (partes.length !== 3) {
            return 'Formato de data inválido';
        }
        // Reorganiza as partes da data no formato DIA-MES-ANO
        const dataFormatada = `${partes[2]}-${partes[1]}-${partes[0]}`;
        return dataFormatada;
    }



    const {
        register,
        setValue,
        handleSubmit,
        setFocus,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });



    useEffect(() => {
        (async () => {
            const resultado2 = await permite_acesso(usuario[0].email, token, "HomePage");
            setAcesso(resultado2);
            console.log("Resultado do acesso:", resultado2);
        })();
    }, [avaliacao]);

    console.log("Acesso:", acesso);

    console.log("Depois", dataInicio);



    if (!acesso) {

        return (
            <div className="AcessoNegado">
                -- ACESSO NEGADO !!! --

                <a href="/login"> Voltar ao Login</a>


            </div>
        )
    }

    const handleData = (e) => {
        e.preventDefault();
        let dti = document.querySelector(
            "input[name = inicio]"
        ).value;
        console.log(dti);
        setDataInicio(dti);
        let dtf = document.querySelector(
            "input[name = fim]"
        ).value;
        console.log(dtf);
        setDataFim(dtf);

    }

    const handleCiclo = (e) => {
        e.preventDefault();
        console.log('2023-09-01');
        setDataInicio('2023-09-01');
        console.log('2024-09-31');
        setDataFim('2024-03-31');
    };

    const handleHoje = (e) => {
        e.preventDefault();
        console.log('2023-09-01');
        setDataInicio('2023-09-01');
        console.log(diadehoje);
        setDataFim(diadehoje);
    };

    const handleSoHoje = (e) => {
        e.preventDefault();
        console.log(diadehoje);
        setDataInicio(diadehoje);
        console.log('novaDataFim');
        setDataFim(diadehoje);
    };

    const Experiment = (Nperfil) => {
        if (Nperfil === "GESTOR")
            return (
                <>
                    <NavDropdown.Item href="/unidade/10">Barra da Tijuca</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/01">Bento Ribeiro</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/11">Campo Grande</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/04">Cascadura</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/16">Freguesia</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/15">Ilha do Governador</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/02">Madureira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/13">Mangueira</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/14">Maricá</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/06">Nilópolis</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/17">Recreio</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/03">Santa Cruz</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/09">Seropédica</NavDropdown.Item>
                    <NavDropdown.Item href="/unidade/05">Taquara</NavDropdown.Item>
                </>
            );
        if (Nperfil.startsWith("DIRETOR")) {
            var numerosString = Nperfil.replace("DIRETOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            return (codigoDinamico)


        };
        if (Nperfil.startsWith("SUPERVISOR")) {
            var numerosString = Nperfil.replace("SUPERVISOR", "").trim();
            var numerosArray = numerosString.split("-");
            var codigoDinamico = numerosArray.map(function (cod_unidade) {
                return (
                    <NavDropdown.Item href={`/unidade/${cod_unidade}`}>
                        {unidades[parseInt(cod_unidade)]}
                    </NavDropdown.Item>
                );
            });
            return (codigoDinamico)
        };


    }

    const handleAvaliacaoChange = (event) => {
        setAvaliacao(event.target.value);
    };

    return (

        <div className="Homepage">
            <div className="sticky-top painel">

                <Navbar expand="lg" className="bg-body-tertiary">

                    <Navbar.Brand href="/">
                        <img
                            src="/novo-logo.png"
                            alt="Santa Mônica Rede de Ensino"
                            style={{ width: "40px", height: "40px", marginRight: "10px" }}
                        />
                        <span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>Santa Mônica Rede de Ensino</span>
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <NavDropdown
                                title={<span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>UNIDADES</span>}
                            >
                                {Experiment(perfil[0].perfil)}
                            </NavDropdown>
                            <Nav.Link href={`/ranking`} style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>RANKING DE ALUNOS</Nav.Link>
                            {/* <Nav.Link href={`/ranking-series`} style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }} active>RANKING DE SÉRIES</Nav.Link> */}
                            <NavDropdown title={<span style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>AVALIAÇÃO : {avaliacao}</span>}>
                                {avaliacaoOptions.map(option => (
                                    <NavDropdown.Item
                                        key={option}
                                        onClick={() => setAvaliacao(option)}
                                    >
                                        {option}
                                    </NavDropdown.Item>
                                ))}
                            </NavDropdown>

                        </Nav>
                    </Navbar.Collapse>
                </Navbar>

            </div>
            <br />
            <div className="tabelas">
                <Container>
                    <Row>
                        <center>

                            <h1 style={{ color: "#006cb5", fontFamily: "inherit", fontWeight: "bold" }}>
                                MONITORAMENTO DE NOTAS LANÇADAS
                            </h1>
                        </center>
                    </Row>
                    <br />
                    <Row>
                        <Col lg={2} sm={12}>
                            <center>
                                <Percent_Lanc_Rede_unidade av={avaliacao} />
                            </center>
                        </Col>
                        <Col lg={10} sm={12}>
                            <center>
                                <Percent_Lanc_Rede av={avaliacao} />

                            </center>
                        </Col>
                    </Row>
                    {avaliacao.startsWith("AS") ? null : (
                        <Row>
                            <Col lg={2} sm={12}>
                                <center>
                                    <Prazo_Rede av={avaliacao} />
                                </center>
                            </Col>
                            <Col lg={10} sm={12}>
                                <center>
                                    <Percent_Lanc_Rede_Prazo av={avaliacao} />

                                </center>
                            </Col>
                        </Row>
                    )}

                    <br />
                    <Row>
                        <Col lg={12} sm={12}>
                            <center>
                                <DesempenhoPorFaixa av={avaliacao} />
                            </center>
                        </Col>

                        {/* <Col lg={12} sm={12}>
                            <center>

                                <Media_Comparativa_geral av={avaliacao} />
                            </center>
                        </Col> */}
                        {/* <Col lg={4} sm={12}>
                        <center></center>
                            <Ranking_Alunos_Serie />
                        </center>
                    </Col> */}
                    </Row>

                </Container>

            </div>


        </div>

    );
};

export default Homepage;